export default "__VITE_ASSET__DLCpC$XA__"